import { StorageKeys } from "@/common/constants/storageKeys";
import { Client, Endpoint, Controller, mapUrl } from "@/repository";
import { SignInResult, Response } from "@/repository/models";

export const signOutFn = (): Promise<any> =>
	Client.instance.get(mapUrl(Controller.Account, Endpoint.SignOut));

export const verifyUser = (debugInfoString: string): Promise<Response<SignInResult>> => {
	return Client.instance.get(
		mapUrl(Controller.Account, Endpoint.VerifyUser),
		undefined,
		undefined,
		{ "Debug-Info": debugInfoString }
	);
}

export const signInAzureAD = (
	token: string,
	tenantId: string,
	debugInfoString: string
): Promise<Response<SignInResult>> => {
	const body = {
		Token: token,
		TenantId: tenantId,
	};

	return Client.instance.post(
		mapUrl(Controller.Account, Endpoint.SignInAzureAD),
		body,
		{ "Debug-Info": debugInfoString }
	);
};

export const getTenantId = (): Promise<string> => {
	const cachedTenantId = localStorage.getItem(StorageKeys.DeploymentTenantId);
	if (cachedTenantId) {
		return Promise.resolve(cachedTenantId);
	}

	const azureTenantId = localStorage.getItem(StorageKeys.TIDForAzure);
	return Client.instance.get(mapUrl(Controller.Account, Endpoint.TenantId), {
		azureTenantId,
	});
};

export const setHasCC4TeamsTrue = (): Promise<any> => {
	return Client.instance.post(mapUrl(Controller.Account, Endpoint.SetClientOn));
}